import { isPlatformServer } from "@angular/common";
import {
  Component,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  inject,
} from "@angular/core";
import {
  collection,
  deleteDoc,
  onSnapshot,
  Unsubscribe,
} from "@angular/fire/firestore";
import { IBrowserNotification } from "../interfaces";
import { AuthService } from "../services/auth.service";
import { CookieService } from "../services/cookie.service";
import { FirebaseService } from "../services/firebase.service";
import { LoadingService } from "../services/loading.service";

@Component({
  standalone: true,
  selector: "app-notifications",
  template: "",
})
export class NotificationsComponent implements OnInit, OnDestroy {
  private unsubscribe?: Unsubscribe;
  private destroyed = false;
  private readonly platformId = inject(PLATFORM_ID) as string;
  constructor(
    private loadingService: LoadingService,
    private authService: AuthService,
    private firebaseService: FirebaseService,
    private cookieService: CookieService
  ) {}

  async ngOnInit() {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    const declined = this.cookieService.getCookie("decline_notification");
    if (declined) {
      return;
    }
    // Temporarily removing.
    // this.listenForRemoteNotifications();
  }

  ngOnDestroy() {
    this.destroyed = true;
    this.unsubscribe?.();
  }

  private async listenForRemoteNotifications() {
    if (!(await this.authService.whenResolved()) || this.destroyed) {
      return;
    }

    const uid = this.authService.uid();
    if (!uid) {
      return;
    }
    // This call may be problematic.
    this.unsubscribe = onSnapshot(
      collection(
        this.firebaseService.firestore,
        `users/${uid}/browser-notifications`
      ),
      async (snaps) => {
        for (const snap of snaps.docs) {
          const notification = snap.data() as IBrowserNotification;
          const _ = new Notification(notification.message);
          deleteDoc(snap.ref);
        }
      },
      (e) =>
        console.error(
          `Failed to read users/${uid}/browser-notifications: ${e}`
        )
    );
  }
}
